module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box",
    style: ({
      'min-width': '1000px'
    })
  }, [_c('div', {
    ref: "head"
  }, [_c('hdHead', {
    attrs: {
      "cTitle": _vm.plive.lName,
      "cEnd": _vm.plive.lEndDt,
      "cIcon": _vm.plive.lBackUrl,
      "cStart": _vm.plive.lStartDt
    }
  })], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content-box",
    staticStyle: {
      "margin-bottom": "60px"
    }
  }, [_c('ul', {
    style: ({
      'height': ((_vm.contentHeight-20) + "px"),
      'overflow-y': 'scroll'
    }),
    attrs: {
      "id": "scroll-box-hd"
    }
  }, [_c('transition-group', {
    attrs: {
      "name": "list-complete"
    }
  }, _vm._l((_vm.listData), function(item, i) {
    return _c('li', {
      key: i,
      staticClass: "clear list-complete-item",
      class: [item.top ? 'active-item' : '', _vm.activeIndex === i ? 'active-c' : '', i % 2 === 0 ? 'jiange' : 0],
      on: {
        "click": function($event) {
          _vm.showItemCon(item, i)
        }
      }
    }, [_c('div', {
      staticClass: "left",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('h1', {
      staticClass: "clear"
    }, [_c('span', {
      staticClass: "left",
      class: [item.ctMtype === '1' ? 'guanliyuan' : '']
    }, [_vm._v(_vm._s(item.ctName))]), _vm._v(" "), _c('span', {
      staticClass: "right",
      staticStyle: {
        "font-size": "12px",
        "color": "#000000",
        "margin-top": "2px"
      }
    }, [_vm._v(_vm._s(_vm._f("formatDate")(item.ctDate)))])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "word-wrap": "break-word",
        "margin-top": "5px",
        "margin-bottom": "3px"
      }
    }, [_vm._v(_vm._s(item.ctContent))])])])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "xs xs1"
  }), _vm._v(" "), _c('div', {
    staticClass: "xs xs2"
  }), _vm._v(" "), _c('div', {
    staticClass: "xs xs3"
  }), _vm._v(" "), _c('div', {
    staticClass: "xs xs4"
  }), _vm._v(" "), _c('div', {
    staticClass: "xs xs5"
  }), _vm._v(" "), _c('div', {
    staticClass: "xs xs6"
  }), _vm._v(" "), _c('div', {
    staticClass: "xs xs7"
  }), _vm._v(" "), _c('div', {
    staticClass: "xs xs8"
  }), _vm._v(" "), _c('div', {
    staticClass: "xs xs9"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.scrollToBottomFlag && _vm.newNum > 0),
      expression: "!scrollToBottomFlag && newNum>0"
    }],
    staticClass: "new-nums"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.moveToBottom(true, 'Quint.easeOut')
      }
    }
  }, [_vm._v(_vm._s(_vm.newNum) + "条新消息")])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showCurrContent) ? _c('div', {
    staticClass: "cover",
    on: {
      "click": function($event) {
        _vm.showCurrContent = false
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.showCurrContent) ? _c('div', {
    staticClass: "fix-box"
  }, [_c('b', {
    staticClass: "bar bar1"
  }), _vm._v(" "), _c('b', {
    staticClass: "bar bar2"
  }), _vm._v(" "), _c('div', {
    staticClass: "bar-2"
  }, [_c('i', {
    staticClass: "bar-1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "bar-22"
  }, [_c('i', {
    staticClass: "bar-1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "fix-box2",
    class: [_vm.showCurrContent ? 'active' : '']
  }, [_c('h1', {
    staticClass: "fix-box-title"
  }, [_vm._v(_vm._s(_vm.currentContent.ctName))]), _vm._v(" "), _c('p', {
    staticClass: "fix-box-time"
  }, [_vm._v(_vm._s(_vm._f("formatDate")(_vm.currentContent.ctDate)))]), _vm._v(" "), _c('img', {
    staticClass: "fix-box-logo",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "src": require("./logo.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-tip"
  }), _vm._v(" "), _c('div', {
    staticClass: "fix-box-content"
  }, [_vm._v("\n          " + _vm._s(_vm.currentContent.ctContent) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "fix-box-bottom"
  })]), _vm._v(" "), _c('div', {
    staticClass: "fix-box-close",
    on: {
      "click": function($event) {
        _vm.showCurrContent = false
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    ref: "footer-box",
    staticClass: "footer1"
  }, [_c('img', {
    attrs: {
      "src": require("./bottom_logo.png"),
      "alt": ""
    }
  })])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "center",
      "position": "relative",
      "margin-top": "30px"
    }
  }, [_c('p', {
    staticClass: "page-title"
  }, [_vm._v("实时互动")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ee4e929a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tpl2/hdList/hdList.vue
// module id = 827
// module chunks = 10